/* eslint-disable no-alert */
/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import { Icon, Button, Header, Form, Modal } from 'semantic-ui-react'

import PhoneField from '../fields/phoneField'
import VattinField from '../fields/vattinField'
import CustomizedNameField from '../fields/customizedNameField'
import CustomizedAddressField from '../fields/customizedAddressField'

import RestaurantActions from '../../../reducers/restaurantReducer'

const initialData = {
  phone: '',
  vattin: '',
  name: { en: '', kh: '' },
  address: { en: '', kh: '' },
}

class VendorInfoForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    loading: false,
    ...initialData,
  }

  componentDidMount() {
    const { vendorData } = this.props

    if (vendorData.official_info) {
      const { name, phone, vattin, address } = vendorData.official_info

      this.setState({ name, phone, vattin, address })
    }
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onSave = async e => {
    e.preventDefault()

    const { onClose, vendorData, storeId, setBranch, setRestaurant, actionType } = this.props
    const { name, phone, vattin, address } = this.state

    await this.setStateAsync({ loading: true })

    const officialInfoData = { name, phone, vattin, address }

    if (actionType === 'branch') {
      const path = `restaurants/${storeId}/branches/${vendorData.key}/official_info`

      await firebase
        .database()
        .ref(path)
        .update(officialInfoData)
        .then(() => setBranch(storeId, vendorData.key, { ...vendorData, official_info: officialInfoData }))
        .catch(() => alert('Fail to create vendor info.'))
    } else {
      const path = `restaurants/${storeId}/official_info`

      await firebase
        .database()
        .ref(path)
        .update(officialInfoData)
        .then(() => setRestaurant(storeId, { ...vendorData, official_info: officialInfoData }))
        .catch(() => alert('Fail to create vendor info.'))
    }

    await this.setStateAsync({ loading: false })
    onClose()
  }

  onRemove = async () => {
    const { onClose, vendorData, storeId, setBranch, setRestaurant, actionType } = this.props

    await this.setStateAsync({ loading: true })

    if (actionType === 'branch') {
      const path = `restaurants/${storeId}/branches/${vendorData.key}/official_info`

      await firebase
        .database()
        .ref(path)
        .remove()
        .then(() => setBranch(storeId, vendorData.key, { ...vendorData, official_info: null }))
        .catch(() => alert('Fail to remove vendor information.'))
    } else {
      const path = `restaurants/${storeId}/official_info`

      await firebase
        .database()
        .ref(path)
        .remove()
        .then(() => setRestaurant(storeId, { ...vendorData, official_info: null }))
        .catch(() => alert('Fail to remove vendor information.'))
        .finally(() => this.setState(initialData))
    }

    await this.setStateAsync({ loading: false })
    onClose()
  }

  onTextChange = (field, locale, value) => {
    this.setState(prevState => ({
      [field]: {
        ...prevState[field],
        [locale]: value,
      },
    }))
  }

  render() {
    const { onClose, visible, vendorData } = this.props

    const { name, phone, address, vattin, loading } = this.state

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={`Vendor Info (${vendorData.name})`} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            disabled={loading}
            ref={ref => {
              this.formRef = ref
            }}
          >
            <Form.Group widths="equal">
              <CustomizedNameField
                label="Company name in English"
                placeholder="e.g Muuve Pizza"
                value={name.en}
                onChange={value => this.onTextChange('name', 'en', value)}
              />
              <CustomizedNameField
                label="Company name in Khmer"
                placeholder="e.g ម៉ូវ ភីហ្សា"
                value={name.kh}
                onChange={value => this.onTextChange('name', 'kh', value)}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <PhoneField
                required
                value={phone}
                onChange={(field, value) => this.setState({ [field]: value })}
              />
              <VattinField onChange={value => this.setState({ vattin: value })} value={vattin} />
            </Form.Group>

            <Form.Group widths="equal">
              <CustomizedAddressField
                label="Address in English"
                placeholder="e.g St.102, #28, PP"
                value={address.en}
                onChange={value => this.onTextChange('address', 'en', value)}
              />
              <CustomizedAddressField
                label="Address in Khmer"
                placeholder="e.g ផ្លូវ 102, ផ្ទះលេខ 28, PP"
                value={address.kh}
                onChange={value => this.onTextChange('address', 'kh', value)}
              />
            </Form.Group>

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon
            color="red"
            floated="left"
            loading={loading}
            disabled={loading}
            onClick={this.onRemove}
          >
            <Icon name="delete" /> Remove
          </Button>

          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapDispatch = {
  setBranch: RestaurantActions.setBranchData,
  setRestaurant: RestaurantActions.saveRestaurantSuccess,
}

export default connect(
  null,
  mapDispatch
)(VendorInfoForm)



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/vendorInfoForm.js